import "./App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// Lazy load components for better performance
const HybridPortfolio = lazy(() => import("./hybrid-portfolio/HybridPortfolio"));
const TerminalView = lazy(() => import("./pages/TerminalView"));
const LoginView = lazy(() => import("./pages/LoginView"));

// Loading component
const LoadingFallback = () => (
  <div className="w-full h-screen flex items-center justify-center bg-[#252422]">
    <div className="w-12 h-12 rounded-full border-4 border-[#EB5E28] border-t-transparent animate-spin"></div>
  </div>
);

function App() {
  return (
    <div className="App">
      <Router>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<HybridPortfolio />} />
            <Route path="/terminal" element={<TerminalView />} />
            <Route path="/login" element={<LoginView />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
